import {
  AssignOtoIndividualHostFamilyRequestInput,
  ChangeOtoIndividualHostFamilyRequestInput,
  UnassignOtoIndividualHostFamilyRequestInput
} from '../../lib/types/models/enrollment/oto-individual-host-family'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const assignOtoIndividualHostFamily = (
  input: AssignOtoIndividualHostFamilyRequestInput
) => {
  const { enrollmentId, hostFamilyId } = input

  return restApiClient
    .url(
      constructApiUrl(API.enrollments.assignOtoIndividualHostFamily.url, {
        id: enrollmentId,
        hostFamilyId
      })
    )
    .post()
}

export const unassignOtoIndividualHostFamily = (
  input: UnassignOtoIndividualHostFamilyRequestInput
) => {
  const { enrollmentId, ...rest } = input

  return restApiClient
    .url(
      constructApiUrl(API.enrollments.unassignOtoIndividualHostFamily.url, { id: enrollmentId })
    )
    .post(rest)
}

export const changeOtoIndividualHostFamily = (
  input: ChangeOtoIndividualHostFamilyRequestInput
) => {
  const { enrollmentId, hostFamilyId, ...rest } = input

  return restApiClient
    .url(
      constructApiUrl(API.enrollments.changeOtoIndividualHostFamily.url, {
        id: enrollmentId,
        hostFamilyId
      })
    )
    .post(rest)
}
